





















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class WyreQuotationPanel extends Vue {
  @Prop() quotation;

  @Prop() cryptoAsset;

  @Prop() fiatAsset;

  get meta() {
    const format = this.$common.utils.number.format;
    const symbol = this.cryptoAsset?.symbol ?? "";
    const fiat = this.fiatAsset?.id;
    const exchangeRateLabel = this.$t("trade.cash-in.exchange-rate", {
      symbol
    });
    const exchangeRate = this.quotation?.exchangeRate ?? "0";
    const fees = this.quotation?.fees ?? {};
    const transactionFee = fees[this.fiatAsset?.id ?? ""] ?? "0";
    let networkFee = fees[this.cryptoAsset?.symbol ?? ""] ?? "0";
    if (Number(networkFee) && Number(exchangeRate)) {
      networkFee = Number(networkFee) / Number(exchangeRate);
      networkFee = format({ n: networkFee, p: 2 });
    }
    const total = this.quotation?.sourceAmount ?? "0";
    return {
      exchangeRateLabel,
      total: `${total} ${fiat}`,
      transactionFee: `${transactionFee} ${fiat}`,
      networkFee: `${networkFee} ${fiat}`,
      exchangeRate: `${format({ n: exchangeRate })} ${fiat}`
    };
  }
}
export default WyreQuotationPanel;
